import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

import BaseOrderView from './BaseOrderView';

const ROWS = [
  'tradeDate',
  'price',
  'missingPrice',
  'vol',
  'priceNot',
  'publicationDate',
  'transactionID',
  'notionalAmt',
  'notionalCcy',
  'flags',
  'status',
  'qtyMeasUnit',
  'qtyPerMeas',
  'type',
  'cleared',
  'thirdCountryExecutionVenue'
];

class IndividualTradeDisplayView extends Component {
  prepareData() {
    let data = this.props.order.data;

    let gridColumns = [
      {
        field: 0,
        width: '9em'
      }
    ].concat(
      data[ROWS[0]].map((rowKey, index) => ({
        field: index + 1,
        columnHeader: `${strings.dataViewing.tableHeaders.trade} ${index + 1}`,
        width: '12em'
      }))
    );

    this.props.order.data = ROWS.map((rowKey) => {
      data[rowKey].unshift(strings.dataViewing.individualTradeViewRows[rowKey]);
      return data[rowKey];
    });

    return gridColumns;
  }

  render() {
    const gridColumns = this.prepareData();
    return (
      <div className="trade-display">
        <BaseOrderView tradeDisplay={true} gridColumns={gridColumns} {...this.props} />
      </div>
    );
  }
}

export default IndividualTradeDisplayView;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/IndividualTradeDisplayView.jsx